export const getTimeAgo = (date?: Date) => {
  // just now (less than 1 minute)
  // 1 minute ago
  // 3 minutes ago
  // 10 minutes ago
  // 1 hour ago
  // 6 hours ago
  // 1 day ago
  // 3 days ago
  // 6 days ago
  // April 21
  // December 12, 2024

  // If not valid date
  if (!date || date.toString() === "Invalid Date" || !date?.getTime)
    return "Just now";

  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  // Less than a minute
  if (seconds < 60) {
    return "Just now";
  }

  // Minutes
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
  }

  // Hours
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
  }

  // Days
  const days = Math.floor(hours / 24);
  if (days < 7) {
    return days === 1 ? "1 day ago" : `${days} days ago`;
  }

  // Date formatting for older dates
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const currentYear = now.getFullYear();

  // If same year, just show month and day
  if (year === currentYear) {
    return `${month} ${day}`;
  }

  // If different year, show month, day, and year
  return `${month} ${day}, ${year}`;
};
